import { Component, OnInit } from '@angular/core';
import { IBreadCrumb } from 'src/app/data-models/Ibreadcrumb.interface';
import { BreadcrumbsService } from 'src/app/services/breadcrumb.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

  constructor(
    private breadCrumbsService : BreadcrumbsService
  ) { }

  ngOnInit() {
    this.updateBreadCrumbs();
  }

  updateBreadCrumbs()
  {
    let newBreadCrumbs : Array<IBreadCrumb> = new Array();

    newBreadCrumbs.push({
      label: "Privacy policy",
      path: "/privacy",
      active: true
    })

    this.breadCrumbsService.breadcrumbs.next(newBreadCrumbs);
  }

}
